// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pfacEntity from './entities/pfac.json';
import pfacMenu from '../pages/pfac/menu.json';
import pfacFullForm from '../pages/pfac/forms/full.json';
import pfacContextForm from '../pages/pfac/forms/context.json';
import pfacMiniForm from '../pages/pfac/forms/mini.json';
import pfacLookupForm from '../pages/pfac/forms/lookup.json';
import pfacTableView from '../pages/pfac/views/table.json';
import pfacStagesView from '../pages/pfac/views/stages.json';
import pfacCardsView from '../pages/pfac/views/cards.json';
import pfacInlineView from '../pages/pfac/views/inline.json';
import pfacBacklogView from '../pages/pfac/views/backlog.json';
import pfacSplitView from '../pages/pfac/views/split.json';
import pfacCalendarView from '../pages/pfac/views/calendar.json';
import pfacDashboardView from '../pages/pfac/views/dashboard.json';
import pfacFmatrixView from '../pages/pfac/views/fmatrix.json';

/** Тип запису «Чинник» зі сторінками пакета: меню, форми та подання з pages/pfac/. */
export const pfacDefinition: IRecordTypeDefinition = {
  ...pfacEntity,
  views: assembleViewSet({
      table: pfacTableView,
      stages: pfacStagesView,
      cards: pfacCardsView,
      inline: pfacInlineView,
      backlog: pfacBacklogView,
      split: pfacSplitView,
      calendar: pfacCalendarView,
      dashboard: pfacDashboardView,
      fmatrix: pfacFmatrixView,
  }),
  form: pfacFullForm,
  forms: { full: pfacFullForm, context: pfacContextForm, mini: pfacMiniForm, lookup: pfacLookupForm },
  menu: pfacMenu,
} as IRecordTypeDefinition;
